import { api , base_url_v1 , base_url_v2 } from "./api";

export const DashboardApi = async () => {
    const data = await api({ url: `${base_url_v2}company/base-request`, method: "GET" , token:true })
    return { data };
}

export const PlanApi = async () => {
    const data = await api({ url: `${base_url_v2}company/plan-info`, method: "GET" , token:true })
    return { data };
}

export const ProfileApi = async () => {
    const data = await api({ url: `${base_url_v2}me`, method: "GET" , token:true })
    return { data };
}


